import ApiClient from '../api/apiClient';

const DASHBOARD = '/user/dashboard';
const DASHBOARD_STATUS_COUNT = '/user/dashboard-status-count';
const CPD_OVERVIEW_DETAILS = '/user/admin-overview-cpd-matrix';
const RENEWAL_OVERVIEW_DETAILS = '/user/admin-overview-renewal-matrix';
const APPLICATION_OVERVIEW_DETAILS = '/user/admin-overview-application-matrics';

const getDashboardData = ({ start_date, end_date, trend_year, tab_type }) => {
  const baseUrl = `${DASHBOARD}?`;
  let queryParams = '';
  if (start_date) queryParams += `&start_date=${start_date}`;
  if (end_date) queryParams += `&end_date=${end_date}`;
  if (trend_year) queryParams += `&trend_year=${trend_year}`;
  if (tab_type) queryParams += `&tab_type=${tab_type}`;
  const url = baseUrl + queryParams;
  return ApiClient.get(url);
};

const getDashboardStatusCount = () => {
  return ApiClient.get(DASHBOARD_STATUS_COUNT);
};

const getApplicationOverviewDetails = ({ start_date, end_date, trend_year, tab_type }) => {
  const baseUrl = `${APPLICATION_OVERVIEW_DETAILS}?`;
  let queryParams = '';
  if (start_date) queryParams += `&start_date=${start_date}`;
  if (end_date) queryParams += `&end_date=${end_date}`;
  if (trend_year) queryParams += `&trend_year=${trend_year}`;
  if (tab_type) queryParams += `&tab_type=${tab_type}`;
  const url = baseUrl + queryParams;
  return ApiClient.get(url);
};

const getCpdOverviewDetails = ({ start_date, end_date, trend_year, tab_type }) => {
  const baseUrl = `${CPD_OVERVIEW_DETAILS}?`;
  let queryParams = '';
  if (start_date) queryParams += `&start_date=${start_date}`;
  if (end_date) queryParams += `&end_date=${end_date}`;
  if (trend_year) queryParams += `&trend_year=${trend_year}`;
  if (tab_type) queryParams += `&tab_type=${tab_type}`;
  const url = baseUrl + queryParams;
  return ApiClient.get(url);
};

const getRenewalOverviewDetails = ({ start_date, end_date, trend_year, tab_type }) => {
  const baseUrl = `${RENEWAL_OVERVIEW_DETAILS}?`;
  let queryParams = '';
  if (start_date) queryParams += `&start_date=${start_date}`;
  if (end_date) queryParams += `&end_date=${end_date}`;
  if (trend_year) queryParams += `&trend_year=${trend_year}`;
  if (tab_type) queryParams += `&tab_type=${tab_type}`;
  const url = baseUrl + queryParams;
  return ApiClient.get(url);
};

export const dashboardService = {
  getDashboardData,
  getDashboardStatusCount,
  getCpdOverviewDetails,
  getRenewalOverviewDetails,
  getApplicationOverviewDetails,
};
